import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/baxmusic.webp';
import screenshot_target from '../../../images/letterfunnel/jochananbax.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jochanan Bax"
      firstname="Jochanan"
      companyname="Bax Music"
      competition="Thomann en Gear4music"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jochananbax.js